<template>
    <v-app>
        <nav>
            <v-app-bar app color="light-green" dark>
                <v-toolbar-title class="headline text-uppercase">YodaCloud</v-toolbar-title>
                <v-spacer/>
              <y-auth-button v-model="isAuth"/>
            </v-app-bar>
        </nav>

        <v-content>
            <router-view v-if="isAuth"/>
            <v-container v-else>
                <div class="d-flex justify-center">
                    <v-progress-linear indeterminate v-if="!isAuth"/>
                    <span v-else>Connexion nécessaire</span>
                </div>
            </v-container>
        </v-content>

    </v-app>
</template>

<script>


	export default {
		name: 'App',
		data() {
			return {
        isAuth: false
      }
		},
		watch: {
			isValidatingSession(newVal) {
				if (!newVal) {
					if (!this.isAuthenticated || !this.isAuthorized) {
						this.$refs.authButton.showDialog();
					} else {
						this.$refs.authButton.closeDialog();
					}
				}
			}
		}
	}

</script>

